import { CanActivateFn, Router } from '@angular/router';
import { inject } from '@angular/core';
import { AuthService } from '../services/auth.service';
import { APP_PATHS } from '../config/app-paths';
import { map, take } from 'rxjs';

export const TermsAndConditionsGuard: CanActivateFn = (_, state) => {
  const authService = inject(AuthService);
  const router = inject(Router);

  return authService.checkTermsAndConditions$().pipe(
    map((termsChanged) =>
      termsChanged
        ? router.createUrlTree([`${APP_PATHS.termsAndConditions}`])
        : true,
    ),
    take(1),
  );
};
